// Reusable JSON-LD structured data component for SEO.
// Renders one or more schema.org objects as <script type="application/ld+json"> tags.
//
// Usage:
//   <JsonLd data={{ "@context": "https://schema.org", "@type": "Organization", ... }} />
//   <JsonLd data={[orgSchema, faqSchema, softwareSchema]} />

type JsonLdData = Record<string, unknown>;

interface JsonLdProps {
  /** A single schema.org object or an array of objects to render as JSON-LD. */
  data: JsonLdData | JsonLdData[];
}

export default function JsonLd({ data }: JsonLdProps) {
  const items = Array.isArray(data) ? data : [data];

  return (
    <>
      {items.map((item, index) => (
        <script
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(item) }}
        />
      ))}
    </>
  );
}
